if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // const formData = new FormData(this.form);
        // if (this.cart) {
        //   formData.append(
        //     'sections',
        //     this.cart.getSectionsToRender().map((section) => section.id)
        //   );
        //   formData.append('sections_url', window.location.pathname);
        //   this.cart.setActiveElement(document.activeElement);
        // }
        // config.body = formData;
        const formData = new FormData(this.form);

/* -------- Coffee Properties -------- */

const coffeeSelects = document.querySelectorAll('.grind-select');

coffeeSelects.forEach((select, index) => {

  if (select.value !== '') {

    formData.set(
      `properties[Coffee ${index + 1}]`,
      select.value
    );

  }

});

/* Discovery Club */

// if (window.isDiscoveryClub) {

//   formData.set(
//     'properties[Coffee 3]',
//     'Tikra Discovery Single Origin'
//   );

// }

if (window.isDiscoveryClub) {

  // Add Coffee 3 automatically
  formData.set(
    'properties[Coffee 3]',
    'Tikra Discovery Single Origin'
  );

  // Count selected coffees
  let selectedCoffee = 0;

  coffeeSelects.forEach((select) => {
    if (select.value !== '') {
      selectedCoffee++;
    }
  });

  // Quantity logic
  if (selectedCoffee >= 2) {
    // Coffee 1 + Coffee 2 + Tikra Coffee 3
    formData.set('quantity', 3);
  } else {
    // Before both coffees are selected
    formData.set('quantity', 1);
  }



}
/* -------- End -------- */

if (this.cart) {
  formData.append(
    'sections',
    this.cart.getSectionsToRender().map((section) => section.id)
  );
  formData.append('sections_url', window.location.pathname);
  this.cart.setActiveElement(document.activeElement);
}

config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // CartPerformance.measure("add:paint-updated-sections", () => {
              //   this.cart.renderContents(response);
              // });
CartPerformance.measure("add:paint-updated-sections", () => {

  this.cart.renderContents(response);

  // Reset Coffee selectors
  document.querySelectorAll('.grind-select').forEach(function(select){

      select.selectedIndex = 0;

      select.classList.remove('active');

      const wrapper = select.closest('.select');
      if(wrapper){
          wrapper.classList.remove('active');
      }

  });

  // Reset Quantity
  const qty = document.querySelector('input[name="quantity"]');

  if(qty){
      qty.value = 1;
      qty.dispatchEvent(new Event('change', {
          bubbles:true
      }));
  }

  // Reset Discovery Club
  const discoveryInput = document.getElementById('DiscoveryClubInput');

  if(discoveryInput){
      discoveryInput.value = '';
  }

});
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
